import React from "react";
import "./Product_track_details.css";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import Purple_border_btn from "../../common_components/common_btn/purple_border_btn/Purple_border_btn";
import { useNavigate } from "react-router-dom";

function Product_track_details() {
  const navigate = useNavigate();
  return (
    <>
      <section className="Product_track_details">
        {/* Top Buttons */}

        <div className="top_btns">
          <Purple_border_btn btnText={"Return Order"} />
          <Purple_border_btn btnText={"Cancel Order"} />

          <Purple_Btn
            btnText={"View Product Details"}
            onClick={() => navigate("/luxury/ordered-product-details")}
          />
        </div>

        {/* Main Card */}
        <div className="white_card">
          {/* Product Name + Order Number */}
          <div className="head_div">
            <h2 className="product_title">GPAC URI PITCHER</h2>

            <div className="order_meta">
              <p className="order_number">
                ORDER NUMBER : <span>0005-12122023</span>
              </p>
              <p className="payment_text">Payment : Online</p>
            </div>
          </div>

          {/* Order Tracking */}
          <div className="section_div">
            <h3 className="section_title">ORDER TRACKING</h3>

            <div className="tracking_wrapper">
              {/* Step 1 */}
              <div className="track_row">
                <div className="left_track">
                  <span className="dot active"></span>
                  <span className="line"></span>
                </div>

                <div className="track_card">
                  <div className="track_icon">
                    <img
                      src="/assest/luxury_images/other/order.png"
                      alt="icon"
                    />
                  </div>

                  <div className="track_text">
                    <p className="track_label">Order Placed</p>
                  </div>

                  <div className="track_date">
                    <p>6 May, 2025, 11:45 am</p>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="track_row">
                <div className="left_track">
                  <span className="dot active"></span>
                  <span className="line"></span>
                </div>

                <div className="track_card">
                  <div className="track_icon">
                    <img
                      src="/assest/luxury_images/other/shipping.png"
                      alt="icon"
                    />
                  </div>

                  <div className="track_text">
                    <p className="track_label">Shipping</p>
                  </div>

                  <div className="track_date">
                    <p>7 May, 2025</p>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="track_row last">
                <div className="left_track">
                  <span className="dot"></span>
                </div>

                <div className="track_card">
                  <div className="track_icon">
                    <img
                      src="/assest/luxury_images/other/delivery.png"
                      alt="icon"
                    />
                  </div>

                  <div className="track_text">
                    <p className="track_label">Delivery On</p>
                  </div>

                  <div className="track_date">
                    <p>10 May, 2025</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Order Details */}
          <div className="section_div">
            <h3 className="section_title">ORDER DETAILS</h3>

            <div className="details_box">
              <Row className="details_row">
                <Col xs={8}>
                  <p className="left">Price Details :</p>
                </Col>
                <Col xs={4}>
                  <p className="right">1 Item</p>
                </Col>
              </Row>

              <Row className="details_row">
                <Col xs={8}>
                  <p className="left">Total Price :</p>
                </Col>
                <Col xs={4}>
                  <p className="right">₹ 0000</p>
                </Col>
              </Row>

              <Row className="details_row">
                <Col xs={8}>
                  <p className="left">Total Additional Charges :</p>
                </Col>
                <Col xs={4}>
                  <p className="right">₹ 50</p>
                </Col>
              </Row>

              <Row className="details_row bold">
                <Col xs={8}>
                  <p className="left">Gross Total Price :</p>
                </Col>
                <Col xs={4}>
                  <p className="right">₹ 0000</p>
                </Col>
              </Row>
            </div>
          </div>

          {/* Delivery Address */}
          <div className="section_div">
            <h3 className="section_title">DELIVERY ADDRESS</h3>

            <div className="address_box">
              <p className="name">
                Oshin Kawale <span>(9876543210)</span>
              </p>

              <p className="addr">
                Teerth Techno Space, Unit B-505, 5th Floor, Pune Bangalore
                Highway Pashan, Pune - 411021
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Product_track_details;
